import lazyChunk from '../components/Async/lazyChunk';
import {FroalaView} from '../../../packages/plugins/vue-froala-wysiwyg/src/froala-view';
import './viewStyles';

// На уровне модуля, а не внутри registerFroala: у трёх точек входа должна быть
// ОДНА функция-фабрика — Vue кеширует резолв на самом объекте функции.
//
// Вынесено в отдельную константу (а не инлайн внутрь lazyChunk(...)), потому
// что та же самая функция нужна отдельно, в preloadFroalaEditor() ниже, —
// см. её комментарий про то, зачем предзагрузка вообще существует.
const loadEditorChunk = () => import(/* webpackChunkName: "froala-editor" */ './editorChunk');
const froalaEditor = lazyChunk(loadEditorChunk);

/**
 * Предзагрузка чанка редактора в обход Vue-компонента — с промисом,
 * доступным вызывающему коду.
 *
 * Асинхронный компонент выше (`froalaEditor`) сам решает, что показывать на
 * время загрузки (задержка, потом `ChunkLoading`, при провале —
 * `ChunkError`), но НЕ сообщает потребителю момент готовности: единственный
 * наблюдаемый эффект — подмена рендера, когда чанк уже приехал. Полю
 * комментария (Comments.vue) нужен именно момент готовности: пока чанк едет
 * (до 13 с на плохой сети, см. расчёт в lazyChunk.js), в DOM обязан
 * оставаться рабочий элемент ввода — иначе набранный между фокусом и
 * загрузкой текст молча теряется.
 *
 * `loadEditorChunk()` здесь — тот же самый вызов `import()`, что уходит в
 * lazyChunk выше, а не его копия: единый источник правды для чанка, без
 * риска, что два места разойдутся в пути или в магическом комментарии.
 *
 * Дедуп сетевого запроса при повторном обращении — НЕ следствие этой общей
 * функции. Его обеспечивает сам рантайм webpack, по id чанка
 * (`installedChunks` в `__webpack_require__.e`): даже два РАЗНЫХ вызова
 * `import()` с одинаковым `webpackChunkName` не запросили бы чанк с сети
 * дважды. Второе обращение — из самого async-компонента, когда Comments.vue
 * фактически переключится на `<froala>`, — просто получит уже выполненный
 * запрос. А то, что при этом подмена рендера произойдёт мгновенно, без
 * нового `ChunkLoading`, — это отдельный кеш, `resolveAsyncComponent` на
 * объекте самой фабрики `froalaEditor` (см. lazyChunk.js).
 */
export function preloadFroalaEditor() {
    return loadEditorChunk();
}

/**
 * Регистрация пары компонентов редактора по разные стороны от границы
 * «читать / писать».
 *
 * Одна функция на три точки входа (app.js, app-service.js, public.js): три
 * копии этой регистрации разъехались бы, и расхождение выглядело бы как
 * «в сервисном режиме комментарии без редактора».
 *
 * Заменяет собой `Vue.use(VueFroala)`: плагин пакета регистрировал оба
 * компонента синхронно, и из-за этого движок ехал в стартовый чанк.
 */
export function registerFroala(Vue) {
    Vue.component('FroalaView', FroalaView);
    Vue.component('Froala', froalaEditor);
}
